"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Vine;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Vine(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#010101;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "Vine"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "vine",
    className: "cls-1",
    d: "M85.051,49.761v9.512a44.058,44.058,0,0,1-9.511,1.113C68.8,74.517,56.736,86.639,52.7,88.9a7.08,7.08,0,0,1-7.8-.146c-4.948-2.975-23.715-18.365-29.958-66.744h13.6c3.414,29.046,11.775,43.943,20.958,55.1a75.815,75.815,0,0,0,13.8-19.516c-9.092-4.618-14.623-14.769-14.623-26.58C48.686,19.037,55.568,10,67.343,10c20.976,0,19.388,23.349,14.9,33.135,0,0-8.471,1.679-11.593-3.743a33.2,33.2,0,0,0,1.5-8.854c0-5.714-2.062-8.507-5.184-8.507-3.323,0-5.623,3.121-5.623,9.128.018,14.458,10.844,21.669,23.714,18.6Z"
  })));
}